import { useEffect, useState } from 'react';
import styles from './BookingManagementBookingTable.module.css';
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { FaCirclePlus } from "react-icons/fa6";
import CustomerBookingPopup from 'pages/kunde/customerBookinkPooup/customerBookingPopup';
import BookingListTable from 'components/bookingListTable/BookingListTable';
import { getParentKids } from 'services/get-parents-kids';
import { BookingList } from 'modules/booking';
import { BookingListSortConfig } from 'utils/bookingList';
import { getBlockData } from 'services/workTime/get-block-data';
import { getParentsKidBooking } from 'services/booking/get-parents-kid-bookings';
import { KidsData } from 'modules/profile';
import { FaHistory } from 'react-icons/fa';

export default function BookingManagementBookingTable() {
    const [bookingsData, setBookingsData] = useState<BookingList[]>([]);
    const [sortConfig, setSortConfig] = useState<BookingListSortConfig>({ key: null, direction: 'asc' });
    const [isBookingPopupOpen, setIsBookingPopupOpen] = useState(false);
    const [showFutureBooking, setShowFutureBooking] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState(false);
    const handleOpenBookingPopup = () => setIsBookingPopupOpen(true);
    const handleCloseBookingPopup = () => { setIsBookingPopupOpen(false); fetchData(); }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const kidsDataRes = await getParentKids();
            if (kidsDataRes.kids && kidsDataRes.kids.length > 0) {
                const kidIds = kidsDataRes.kids.map((kid: KidsData) => kid.id);
                if (kidIds.length > 0) {
                    const kidsBookingsData = await getParentsKidBooking(kidIds, undefined, ['confirmed', 'pending', 'rejected'], showFutureBooking);

                    if (kidsBookingsData.success) {
                        const formattedBookingsData = await Promise.all(
                            kidsBookingsData.Kids_bookings_data.map(async (booking: any) => {

                                const kid = kidsDataRes.kids.find((kid: KidsData) => kid.id === booking.kid_id);
                                const block = await getBlockData(booking.work_time_slot_id);
                                let finalStatus = booking.status;
                                if (booking.recurrence === 'serial') {
                                    const recurrenceStatuses = [
                                        booking.recurrence_date_0_status,
                                        booking.recurrence_date_1_status,
                                        booking.recurrence_date_2_status,
                                        booking.recurrence_date_3_status
                                    ];

                                    if (booking.status === 'pending') {
                                        finalStatus = 'offen';
                                    }

                                    else if (booking.status == "confirmed") {
                                        finalStatus = 'bestätigt';
                                        const hasRejected = recurrenceStatuses.includes('rejected');
                                        const hasCancelled = recurrenceStatuses.includes('cancelledConfirmed') || recurrenceStatuses.includes('cancelledPending');
                                        if (hasRejected) {
                                            finalStatus = 'bestätigt (teilweise abgelehnt)';
                                        }
                                        else if (hasCancelled) {
                                            finalStatus = 'bestätigt (teilweise storniert)';
                                        }
                                    }
                                    else if (booking.status === 'rejected') {
                                        finalStatus = 'abgelehnt';
                                    }

                                } else if (booking.recurrence === 'onetime') {
                                    finalStatus = booking.status === 'pending' ? 'offen' : booking.status === 'confirmed' ? 'bestätigt' : 'abgelehnt';
                                }
                                return {
                                    ...booking,
                                    name: `${kid?.first_name} ${kid?.last_name}`,
                                    age: kid?.age,
                                    status: finalStatus,
                                    block: `${booking.start_time.substring(0, 5) || ''} - ${booking.end_time.substring(0, 5) || ''}`,
                                    request_date: booking.request_date?.substring(0, 10) || ''
                                };
                            })
                        );
                        formattedBookingsData.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

                        setBookingsData(formattedBookingsData);
                    } else {
                        console.warn('Fehler beim Abrufen der daten:', kidsBookingsData.message);
                    }
                }
            }

        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [showFutureBooking]);


    const sortedBookings = [...bookingsData].sort((a, b) => {
        if (sortConfig.key) {
            let aValue = a[sortConfig.key];
            let bValue = b[sortConfig.key];
            if (aValue === undefined) return 1;
            if (bValue === undefined) return -1;

            if (
                (sortConfig.key === 'request_date' || sortConfig.key === 'date') &&
                typeof aValue === 'string' &&
                typeof bValue === 'string'
            ) {
                const aDate = new Date(aValue.split('.').reverse().join('-'));
                const bDate = new Date(bValue.split('.').reverse().join('-'));

                if (aDate < bDate) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aDate > bDate) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
            } else {
                if (aValue < bValue) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
            }
        }
        return 0;
    });

    const handleSort = (key: 'name' | 'age' | 'request_date' | 'date' | 'status') => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };


    return (
        <div className={styles.tableContainer}>
            <div className={styles.tableHeader}>
                <h2>Buchungsanfragen</h2>

                <button className={`${commonStyles.commonButton} ${styles.bookingButton}`} onClick={handleOpenBookingPopup}>
                    <p>Neue Buchung</p>
                    <FaCirclePlus className={commonStyles.commonButtonIcon} />
                </button>
            </div>
            <BookingListTable bookings={sortedBookings} onSort={handleSort} sortConfig={sortConfig} isCancel={false} onClose={() => { fetchData(); }} />
            {showFutureBooking &&
                <button className={`${commonStyles.commonButton} ${styles.cancelButton} ${styles.showAllButton}`}
                    onClick={() => setShowFutureBooking(false)}
                >
                    {isLoading ? (
                        <div className={commonStyles.spinner}></div>
                    ) : (
                        "Vorherige Buchungen anzeigen"
                    )}

                    <FaHistory className={commonStyles.commonButtonIcon} />
                </button>}
            <CustomerBookingPopup isOpen={isBookingPopupOpen} onClose={handleCloseBookingPopup} />
        </div>
    );
}
